import { put, takeLatest } from 'redux-saga/effects';
import { mergeTasksIntoCollection } from 'collections/tasks';
import { saveCompanyTasksSagaAction } from '../actions';
import { saveCompanyTasks } from '../slice';
function* saveCompanyTasksSaga({ payload }) {
    const tasks = payload || [];
    yield put(saveCompanyTasks(tasks === null || tasks === void 0 ? void 0 : tasks.map((t)=>t.taskId)));
    // Lite list payload — merge onto existing records instead of replacing them,
    // so an open task drawer's detail fields survive (see save-home-response).
    mergeTasksIntoCollection(tasks, {
        source: 'fetch'
    });
}
export const watchSaveCompanyTasksSaga = function*() {
    yield takeLatest(saveCompanyTasksSagaAction.type, saveCompanyTasksSaga);
};
